<template>
  <div class="login">
    <!-- <img @click="goHome" class="loginlogo" src="../assets/images/loginlogo.png" alt="" srcset="" /> -->
    <div class="loginbox">
      <div @click="goHome"></div>
      <div>
       <div class="tabList">
          <div @click="tabindex(index)" :class="{tabName1 : active == index}" class="tabName" v-for="(item, index) in tabName" :key="index">{{item.name}}</div>
       </div>
       <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" class="demo-dynamic">
         <el-form-item prop="username" :rules="[
               { required: true, message: '请输入您的账号', trigger: 'blur' }
             ]">
             <div class="icondiv">
               <img class="icon" src="../assets/images/phoneIcon@2x.png" alt="" srcset="" />
             </div>

           <el-input v-model="dynamicValidateForm.username" placeholder="请输入您的账号">
           </el-input>
         </el-form-item>
         <el-form-item prop="password" :rules="[
               { required: true, message: '请输入密码', trigger: 'blur' }
             ]">
             <div class="icondiv">
               <img class="icon" src="../assets/images/passIcon@2x.png" alt="" srcset="" />
             </div>
           <el-input type="password" v-model="dynamicValidateForm.password" placeholder="请输入密码">
           </el-input>
         </el-form-item>

         <el-form-item v-if="active == 1" prop="realName" :rules="[
               { required: true, message: '请输入真实姓名', trigger: 'blur' }
             ]">
            <div class="icondiv">
              <img class="icon" src="../assets/images/phoneIcon@2x.png" alt="" srcset="" />
            </div>
           <el-input v-model="dynamicValidateForm.realName" placeholder="请输入真实姓名">
           </el-input>
         </el-form-item>
         <el-form-item v-if="active == 1" prop="phone" :rules="[
               { required: true, message: '请输入手机号', trigger: 'blur' }
             ]">
            <div class="icondiv">
              <img class="icon" src="../assets/images/phoneIcon@2x.png" alt="" srcset="" />
            </div>
           <el-input v-model="dynamicValidateForm.phone" placeholder="请输入手机号">
           </el-input>
         </el-form-item>


         <el-form-item v-if="active == 1" prop="companyName" :rules="[
               { required: true, message: '请输入公司名称', trigger: 'blur' }
             ]">
            <div class="icondiv">
              <img class="icon" src="../assets/images/phoneIcon@2x.png" alt="" srcset="" />
            </div>
           <el-input v-model="dynamicValidateForm.companyName" placeholder="请输入公司名称">
           </el-input>
         </el-form-item>


         <el-form-item>
           <el-button class="logon" type="primary" @click="login(1, 'dynamicValidateForm')">{{active == 1 ? '注册' : '登录'}}</el-button>
         </el-form-item>
       </el-form>
      </div>
    </div>
<!--     <div class="loginbox">
      <div class="logonDiv">
        <div class="goLogon" @click="setRegister">{{flag ? '去注册' : '去登录'}}</div>
      </div>
      <div class="title">欢迎{{flag ? '登录' : '使用'}}方圆云后台系统</div>
      <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" class="demo-dynamic">
        <el-form-item prop="username" :rules="[
              { required: true, message: '请输入您的账号', trigger: 'blur' }
            ]">
            <div class="name">账号</div>
          <el-input v-model="dynamicValidateForm.username" placeholder="请输入您的账号">
          </el-input>
        </el-form-item>
        <el-form-item prop="password" :rules="[
              { required: true, message: '请输入密码', trigger: 'blur' }
            ]">
          <div class="name">密码</div>
          <el-input type="password" v-model="dynamicValidateForm.password" placeholder="请输入密码">
          </el-input>
        </el-form-item>
        <el-form-item v-if="!flag" prop="phone" :rules="[
              { required: true, message: '请输入手机号', trigger: 'blur' }
            ]">
          <div class="name">手机号</div>
          <el-input v-model="dynamicValidateForm.phone" placeholder="请输入手机号">
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button class="logon" type="primary" @click="login(1, 'dynamicValidateForm')">{{flag ? '登录' : '注册'}}</el-button>
        </el-form-item>
      </el-form>
    </div>-->
  </div>
</template>

<script>
  import {
    getRegister,
    getLogin
  } from '@/api/api'
  import JSEncrypt from 'jsencrypt/bin/jsencrypt'
  const publicKey = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBANL378k3RiZHWx5AfJqdH9xRNBmD9wGD\n' +
    '2iRe41HdTNF8RUhNnHit5NpMNtGL0NPTSSpPjjI1kJfVorRvaQerUgkCAwEAAQ=='
  import {
    setCookie
  } from '@/utils/util.js';
  export default {
    data() {
      return {
        active: 0,
        tabName: [{
            name: '登录'
          },
          {
            name: '注册'
          }
          ],
        checked: false,
        userIcon: require('../../src/assets/images/userIcon@2x.png'),
        passIcon: '../../src/assets/images/passIcon@2x.png',
        dynamicValidateForm: {
          username: '',
          password: '',
          phone: '',
          qrPassword: '',
          realName: '',
          companyName: ''
        },

        flag: true,
        loading: false
      }
    },
    created() {
      if(this.$route.params.value == 2) {
        this.active = 1
      }
    },
    methods: {
      tabindex(index) {
        this.active = index
      },
      remember() {
        this.checked = !this.checked
      },
      goHome() {
        this.$router.push({
          path: '/home'
        })
      },
      setEncrypt: function(publicKey, data) {
        const encrypt = new JSEncrypt();
        encrypt.setPublicKey(publicKey);
        return encrypt.encrypt(data);
      },
      setRegister() {
        this.flag = !this.flag
        this.dynamicValidateForm = {
            username: '',
            password: '',
            phone: '',
            qrPassword: '',
            realName: '',
            companyName: ''
          }
      },
      login(val, formName) {
        if (this.loading) {
          return
        }
        this.loading = true
        if (this.active == 0) {
          console.log('1')
          this.$refs[formName].validate((valid) => {
            if (valid) {
              let password = this.setEncrypt(publicKey, this.dynamicValidateForm.password)
              getLogin({
                username: this.dynamicValidateForm.username,
                password,
                phone: this.dynamicValidateForm.phone,
                realName: this.dynamicValidateForm.realName,
                companyName: this.dynamicValidateForm.companyName,
              }).then(res => {
                if (res.code == 1) {
                  localStorage.setItem('fyuser', JSON.stringify(res.data))
                  this.$message({
                    showClose: true,
                    message: '登陆成功',
                    type: 'success'
                  });
                  this.$router.push({
                    path: '/'
                  })
                } else {
                  this.$message.error(res.msg)
                }
                this.loading = false
              })
            } else {
              console.log('error submit!!');
              // return false;
            }
          });

        } else if (this.active == 1) {
          console.log('2')
          this.$refs[formName].validate((valid) => {
            if (valid) {
              console.log('2222222222222222222222')
              this.dynamicValidateForm.qrPassword = this.dynamicValidateForm.password
              getRegister(this.dynamicValidateForm).then(res => {
                if (res.code == 1) {
                  this.dynamicValidateForm = {
                    password: "",
                    phone: "",
                    username: ""
                  }
                  this.loading = false
                  this.flag = true
                  this.$message({
                    showClose: true,
                    message: '注册成功',
                    type: 'success'
                  });
                } else {
                  this.$message.error(res.data)
                }
              })
            } else {
              console.log('error submit!!');
              // return false;
            }
          });
        }

      }
    }
  }
</script>

<style scoped>
  .login {
    width: 100%;
    height: 100vh;
    background: url('../assets/images/loginbj.png') top center no-repeat;
    background-size: 100% 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loginlogo {
    position: absolute;
    width: 131px;
    height: 60px;
    top: 75px;
    left: 100px;
    cursor: pointer;
  }

  .loginbox {
    width: 1280px;
    height: 780px;
    background: #FFFEFF;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .loginbox > div:first-child {
    width: 50%;
    height: 100%;
    background: url('../assets/images/loginleft.png') top center no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
  }

  .loginbox > div:last-child {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .title {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 26px;
    color: #22201E;
    border-bottom: 1px solid #EAF1F8;
    padding-bottom: 20px;
  }

  .name {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 18px;
    color: #22201E;
  }

  .logon {
    width: 388px;
    height: 60px;
    background: #0C2975;
    border-radius: 10px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 20px;
    color: #FFFFFF;
    margin-top: 50px;
  }

  /deep/ .el-input__inner {
    /* height: 60px;
    border-radius: 30px;
    border: 1px solid #D5DFEB; */
    height: 70px;
    background: #F8FAFF;
    border-radius: 10px;
    border: 1px solid #0A2979;
    box-sizing: border-box;
    padding-left: 90px;
    position: relative;
  }

  .demo-dynamic {
    margin-top: 30px;
  }

  .logonDiv {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 40px;
  }

  .goLogon {
    cursor: pointer;
    width: 110px;
    height: 54px;
    background: #0C2975;
    border-radius: 12px;
    font-size: 18px;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    line-height: 54px;
  }

  .tabName {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 32px;
    color: #CDD2DE;
  }

  .tabName1 {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 42px;
    color: #151616;
    position: relative;
    display: flex;
    justify-content: center;
  }

  .tabName1::before {
    position: absolute;
    bottom: -10px;
    content: ' ';
    width: 44px;
    height: 4px;
    background: #0A2979;
  }

  .tabList {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .tabList > div {
    margin-right: 30px;
    cursor: pointer;
  }

  .el-form-item__content {
    position: relative !important;
  }

  .icondiv {
    position: absolute;
    width: 70px;
    height: 100%;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icondiv::before {
    position: absolute;
    content: ' ';
    right: 0px;
    width: 1px;
    height: 44px;
    background: #0A2979;
  }

  .icon {
    width: 20px;
    height: 26px;

  }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue